import { useAuthStore } from "@/stores/authStore";
import type { Tenant } from "@/types/database";

export function useTenant(): Tenant {
  const tenant = useAuthStore((s) => s.tenant);
  if (!tenant) {
    throw new Error("useTenant doit être utilisé dans un contexte authentifié");
  }
  return tenant;
}

export function useTenantOptional(): Tenant | null {
  return useAuthStore((s) => s.tenant);
}
